import React, { useEffect, useState } from "react";
import axios from "axios";
import "../static/quickAppointment.css";

import QuickAppointmentForm from "../components/QuickAppointmentForm";

const QuickAppointments = () => {
  const [items, setItems] = useState([]);

  const fetchItems = async () => {
    const res = await axios.get("/petgrooming/quick-appointments/");
    setItems(res.data || []);
  };

  useEffect(() => {
    fetchItems();
  }, []);

  return (
    <main className="quick-appointments-page">
      <QuickAppointmentForm />
      <section className="quick-appointment-card">
        <div className="quick-appointment-head">
          <span>Incomplete bookings</span>
          <h2>Quick appointments</h2>
          <p>These bookings were created quickly and can be completed later.</p>
        </div>

        <div className="quick-table-wrap">
          <table className="quick-table">
            <thead>
              <tr>
                <th>Dog</th>
                <th>Phone</th>
                <th>Date</th>
                <th>Time</th>
                <th>Status</th>
                <th>Note</th>
              </tr>
            </thead>

            <tbody>
              {items.length > 0 ? (
                items.map((item) => (
                  <tr key={item.id}>
                    <td>{item.dog_name}</td>
                    <td>{item.phone}</td>
                    <td>{item.appointment_date}</td>
                    <td>{item.appointment_hour}</td>
                    <td>{item.status}</td>
                    <td>{item.note || "—"}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6">No quick appointments yet.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </section>
    </main>
  );
};

export default QuickAppointments;